import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/events/:state?',
    name: 'events',
    component: () => import('../views/EventsView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/event/:event',
    name: 'eventDetails',
    component: () => import('../views/EventDetailsview.vue')
  },
  {
    path: '/category/:slug',
    name: 'AllSinglePage',
    component: () => import('../views/AllSinglePage.vue')
  },
  /* new  pages */
  {
    path: '/:url_slug',
    name: 'NewPage',
    component: () => import('../views/NewPage.vue')
  },
  {
    path: '/post/:slug',
    name: 'PostDetails',
    component: () => import('../views/PostDetails.vue')
  },
  // {
  //   path: '/media-center',
  //   name: 'MediaCenter',
  //   component: () => import('../views/MediaCenter.vue')
  // },
  // {
  //   path: '/news-details',
  //   name: 'NewsDetails',
  //   component: () => import('../views/NewsDetails.vue')
  // },
  // {
  //   path: '/publications-details',
  //   name: 'PublicationsDetails',
  //   component: () => import('../views/PublicationsDetails.vue')
  // },
  // {
  //   path: '/case-studies-details',
  //   name: 'CaseStudiesDetails',
  //   component: () => import('../views/CaseStudiesDetails.vue')
  // },
  {
    path: '/individuals',
    name: 'IndividualsView',
    component: () => import('../views/IndividualsView.vue')
  },
  {
    path: '/individual/:id',
    name: 'IndividualDetails',
    component: () => import('../views/IndividualDetails.vue')
  },
  {
    path: '/facilities',
    name: 'Facilities',
    component: () => import('../views/Facilities.vue')
  },
  {
    path: '/facility/:id',
    name: 'FacilityDetails',
    component: () => import('../views/FacilityDetails.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
